export default __webpack_public_path__ + "static/media/DDeal.b9bdb83d.svg";